import { useViewer } from './useViewer';

export function useIsSupport() {
	const viewer = useViewer();

	return viewer?.username === 'support';
}
